// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

const styles = ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 0',
  },
  redeemLinkContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '4px 0 12px 0',
  }
});

export default styles;
